import type { QuoteStatus } from '@catalyst-psa/shared';

export const QUOTE_STATUS_TONES: Record<QuoteStatus, 'gray' | 'blue' | 'green'> = {
  draft: 'gray',
  sent: 'blue',
  approved: 'green',
};
